import { Card, CardHeader, CardTitle } from '@/shared/components/ui/card'
import { BusinessStatusBadge } from '../BusinessStatusBadge'
import { safeFormatDateTime } from '@/shared/utils/formatDate'
import { PAYMENT_STATUS_LABELS, labelOf } from '@/shared/constants'
import type { BusinessDetail } from '../../hooks/useBusiness'

interface BusinessMetaCardProps {
  business: BusinessDetail
}

export function BusinessMetaCard({ business }: BusinessMetaCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Estado y facturación</CardTitle>
      </CardHeader>
      <div className="grid gap-5">
        <div className="flex items-center justify-between gap-3">
          <span className="text-xs uppercase tracking-wide text-ink-subtle">Estado</span>
          <BusinessStatusBadge status={business.status} />
        </div>
        <div className="flex items-center justify-between gap-3">
          <span className="text-xs uppercase tracking-wide text-ink-subtle">Pago</span>
          <span className="text-sm font-medium text-ink">
            {labelOf(PAYMENT_STATUS_LABELS, business.paymentStatus)}
          </span>
        </div>
        <div className="flex items-center justify-between gap-3">
          <span className="text-xs uppercase tracking-wide text-ink-subtle">Día de cobro</span>
          <span className="text-sm font-medium text-ink">
            {business.plannedDayToPay ? `Día ${business.plannedDayToPay}` : '—'}
          </span>
        </div>
        <div className="flex items-center justify-between gap-3">
          <span className="text-xs uppercase tracking-wide text-ink-subtle">Creado</span>
          <span className="text-sm font-medium text-ink">{safeFormatDateTime(business.createdAt, '—')}</span>
        </div>
      </div>
    </Card>
  )
}
